import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

/* Router guards */
import { AuthGuard } from '@core/guards/auth.guard';

const routes: Routes = [
	{
		path: '',
		canActivate: [AuthGuard],
		canLoad: [AuthGuard],
		loadChildren: () =>
			import('./modules/portfolio-overview/portfolio-overview.module').then((m) => m.PortfolioOverviewModule),
	},
	{
		path: 'dashboard',
		canActivate: [AuthGuard],
		canLoad: [AuthGuard],
		loadChildren: () => import('./modules/dashboard/dashboard.module').then((m) => m.DashboardModule),
	},
	{
		path: 'account',
		canActivate: [AuthGuard],
		canLoad: [AuthGuard],
		loadChildren: () => import('./modules/account/account.module').then((m) => m.AccountModule),
	},
	// {
	// 	path: 'insights',
	// 	canActivate: [AuthGuard],
	// 	canLoad: [AuthGuard],
	// 	loadChildren: () => import('./modules/insights/insights.module').then(m => m.InsightsModule)
	// },
	{ path: '**', redirectTo: '/' },
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { useHash: true })],
	exports: [RouterModule],
})
export class AppRoutingModule {}
